export const reportDepositsTypes = {
  GET_REPORT_DEPOSITS: 'GET_REPORT_DEPOSITS',
  SET_REPORT_DEPOSITS_FILTERS: 'SET_REPORT_DEPOSITS_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};